import { render, staticRenderFns } from "./C1148.vue?vue&type=template&id=ff995022&scoped=true"
import script from "./C1148.vue?vue&type=script&lang=js"
export * from "./C1148.vue?vue&type=script&lang=js"
import style0 from "./C1148.vue?vue&type=style&index=0&id=ff995022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff995022",
  null
  
)

export default component.exports